export default "/assets/site/images/orsolya_agota.png?d05b6125c8bb70f5a082dc5ff9e7ed75";